module.exports = {"pageTitleText":"節點配置","createText":"添加節點","hostname":"主機名稱","groupName":"群組","internalIP":"內網地址","externalIP":"外網地址","isEnableProxyProtocol":"代理協議","serviceIP":"服務地址","serviceProvideType":"服務型態","health":"健康度","isenabled":"啟用狀態","connectState":"連接狀態","gitSitesSuccess":"更新狀態","ninjaIsRunning":"Ninja","errMsg":"Error Message","status":"狀態","removeFromGroup":"移除","removeFromGroupText":"您确定要移除此 Ninja Handler吗？"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/ninjasetting.json
// module id = qYp+
// module chunks = 3